export class CategoryReportRepository implements ICategoryReportRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getCategorys(data: ConsultConditions): Promise<CategoryReport[]> {
        const response = await this.httpService.post<APIResponse<CategoryReport>, ConsultConditions>('/v1/report_category/all', { data });
        return response.result.map((category) => ({
            ...category,
            category_id: category.id
        }));
    }
    async createCategory(data: CategoryCreateDTO): Promise<number> {
        const response = await this.httpService.post<CategoryCreateResponse, CategoryCreateDTO>('/v1/report_category/add', { data });
        return response.result[0].id;
    }
    async updateCategory(data: CategoryUpdateDTO): Promise<number> {
        const response = await this.httpService.post<APIResponse<null>, CategoryUpdateDTO>('/v1/report_category/update', { data });
        return response.result.length;
    }
    async deleteCategory(data: { where_delete: WhereConditions }): Promise<number> {
        const response = await this.httpService.post<APIResponse<{id:number}>, { where_delete: WhereConditions }>('/v1/report_category/update', { data });
        return response.result[0].id;
    }
}
